<div
  class="col-xs-12 col-md-12 navy-blue page-heading-strip page-heading-bar no-padding background-white mobile-pos-fixed">
  <div class="col-xs-12 col-md-12">
    <h3 class="page-heading">
      <span class="cursor-pointer">TRANSACTION STATUS</span>
    </h3>
  </div>
</div>


<div class="container-fluid main-fix-footer-pad hide-mobile">
  <section *ngIf="showLoader">
    <app-loader></app-loader>
  </section>
  <div class="col-xs-12 col-md-9 col-lg-9 text-center review-bg">

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center ">
      <img src="assets/congratulation.png" class="payment-failed-icon">
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 div-center">
      <h2 *ngIf="CongratulationScreen  && morethan30 || setTimerCall == 0" class="payment-heading congratulation">
        Congratulations!</h2>
      <h2 *ngIf="CongratulationScreen && policyDownloadResponseList && !bothPoliciesNull && !morethan30"
        class="payment-heading congratulation">Success!</h2>

      <!-- <h2 *ngIf="!CongratulationScreen" class="payment-heading hurray">Hurray!</h2> -->
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding">
      <!-- <div *ngIf="!CongratulationScreen" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-20 payment-label font-bold div-center">
          Payment successful. Your policy issuance is in progress.
        </div> -->
      <!--  -->
      <div *ngIf="CongratulationScreen  && morethan30 || setTimerCall == 0"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-20 payment-label font-bold div-center text-center">
        Your payment is successful and you will receive your policy details on your registered mobile
        number and Email ID within 7 working days
        <!-- Payment successful. Congratulations on securing your health! -->
      </div>
      <div *ngIf="CongratulationScreen && policyDownloadResponseList && !bothPoliciesNull && !morethan30"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-20 payment-label font-bold div-center text-center">
        Payment successful. Congratulations on securing your health!
      </div>
      <!-- <div class="cards d-flex kyc-disclaimer ">
        <img src="../../../assets/icon/Info-icon-kyc.png" class="kyc-icon">
        <span class="kyc-top">{{disclaimer_msg}}</span>
      </div> -->
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 inner-box top-spc-20">
      <div class="col-xs-12 col-md-12 section-spc" *ngIf="planCode">
        <div class="col-xs-2 col-md-2 no-pad">
          <img
            src="{{aemFragmentInfo?.logo?.variations[planCode.toLowerCase() +'_'+ variantCode.toLowerCase()]?.value}}"
            class="partner-logo" alt="bajaj-finserv-logo">
          <div class="skelt-load loader" *ngIf="!isPartnerLogoLoaded"></div>
        </div>
        <div class="col-xs-9 col-md-10 no-padding">
          <div class="partner-name">
            {{aemFragmentInfo?.productName?.variations[planCode.toLowerCase() +'_'+
            variantCode.toLowerCase()]?.value}}
          </div>
          <div class="partner-loan-type">
            {{aemFragmentInfo?.principleName?.variations[planCode.toLowerCase() +'_'+
            variantCode.toLowerCase()]?.value}}

          </div>
        </div>
      </div>
      <div *ngIf="paymentDetail && paymentDetail.paymentMode && (paymentDetail.paymentMode === 'FUNDED' || 
      paymentDetail.paymentMode === 'PARTIALLY FUNDED' || paymentDetail.paymentMode === 'FULLY FUNDED')">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label section-spc">
          <span class="col-xs-6 col-md-6">Loan Account Number</span>
          <span class="col-xs-6 col-md-6 amount-Label">
            {{loanAccountNumber}}</span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label section-spc">
          <span class="col-xs-6 col-md-6">Advance EMI</span>
          <span class="col-xs-6 col-md-6 amount-Label">
            Rs. {{fundingAmount}}</span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label section-spc">
          <span class="col-xs-6 col-md-6">Loan Tenure</span>
          <span class="col-xs-6 col-md-6 amount-Label">
            {{fundingTenor}} Months</span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label section-spc">
          <span class="col-xs-6 col-md-6">1st EMI Due Date</span>
          <span class="col-xs-6 col-md-6 amount-Label">
            {{firstEmiDate}}</span>
        </div>
      </div>
      <div *ngIf="quoteItemDetail && quoteItemDetail.sumassuredamt"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Coverage</span>
        <span class="col-xs-6 col-md-6 amount-Label">
          Rs.{{formatter.ConvertNumberToAmount(quoteItemDetail.sumassuredamt.toString())}}</span>

      </div>
      <div *ngIf="quoteItemDetailAddon && quoteItemDetailAddon.sumassuredamt"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Addon Coverage</span>
        <span class="col-xs-6 col-md-6 amount-Label">
          Rs.{{formatter.ConvertNumberToAmount(quoteItemDetailAddon.sumassuredamt.toString())}}</span>

      </div>
      <div *ngIf="quoteItemDetail && quoteItemDetail.tenure"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Tenure</span>
        <span class="col-xs-6 col-md-6 amount-Label"> {{quoteItemDetail.tenure}} {{quoteItemDetail.tenure === 1 ?
          'Year': 'Years'}}</span>
      </div>
      <ng-container *ngFor="let policyDownloadResponse of policyDownloadResponseList; let i = index">

        <div *ngIf="CongratulationScreen && policyDownloadResponseList && !morethan30"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center mb-0 section-spc">
          <span class="col-xs-6 col-md-6">Policy Number</span>
          <span class="col-xs-6 col-md-6 policyNum">
            <div>
              <div>
                <div *ngIf="policyDownloadResponse.policyNumber" [ngClass]="i === 0 ? bottom-margin-20 : ''">
                  <h5 class="font15">
                    <!-- {{ policyDownloadResponse.title }}<strong>:</strong> -->
                    <div><span class="lato-bold">{{policyDownloadResponse.policyNumber}}</span>
                      <span class="cursor-pointer" *ngIf="principalCode !== 'ABHI' && planCode !== 'MAXBUPAIH'"
                        (click)="DownloadPolicy(policyDownloadResponse)">
                        <img class="vehicles-logo light-icon-display left-pad" src="assets/img/png/download_icon.png">
                        <img class="vehicles-logo dark-icon-display left-pad" src="assets/download-dark.png"></span>
                    </div>
                    <h4 class="download-text" *ngIf="principalCode !== 'ABHI' && planCode !== 'MAXBUPAIH'">Please click
                      here to download your policy
                      copy. <span *ngIf="planCode ==='MAXBUPAIH'"> This is password protected and the password is the
                        Proposer's DOB in DDMMYYYY format</span>
                    </h4>
                  </h5>
                </div>
              </div>
            </div>
          </span>
        </div>

        <div *ngIf="CongratulationScreen && policyDownloadResponseList && policyDownloadResponse.proposalNumber"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
          <span class="col-xs-6 col-md-6">Application Number</span>
          <span class="col-xs-6 col-md-6 policyNum">
            <div>
              <div>
                <div [ngClass]="i === 0 ? bottom-margin-20 : ''">
                  <h5 class="font15 policy-txt">
                    <div>{{policyDownloadResponse.proposalNumber}}

                    </div>
                  </h5>
                </div>
              </div>
            </div>
          </span>
        </div>

      </ng-container>

      <div *ngIf="quoteDetail && quoteDetail.grossPremiumAmount"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Total Premium</span>
        <span class="col-xs-6 col-md-6 amount-Label">
          Rs.{{formatter.ToCurrency(quoteDetail.grossPremiumAmount.toString())}}</span>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Transaction ID</span>
        <span class="col-xs-6 col-md-6 amount-Label"> {{paymentId}}</span>
      </div>

      <div *ngIf="applicationId"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Application ID</span>
        <span class="col-xs-6 col-md-6 amount-Label"> {{ applicationId }}</span>
      </div>

      <div *ngIf="quoteId" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 payment-label top-5 div-center section-spc">
        <span class="col-xs-6 col-md-6">Quote ID</span>
        <span class="col-xs-6 col-md-6 amount-Label"> {{ quoteId }}</span>
      </div>

      <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-40 margin-btm-20" *ngIf="!CongratulationScreen && principalCode === 'BAGIC'">
        <button id="btnCongratulationExploare" class="btn btn-primary btn-block btnconfirm top-spc-50 btn-single fixed" (click)="Next()">
          PROCEED
        </button>
      </div> -->
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 top-spc-40 margin-btm-20"
        *ngIf="CongratulationScreen || setTimerCall == 0">
        <button class="btn btn-primary btn-block btnconfirm top-spc-50 btn-single fixed"
          (click)="ExploreMore('INSINSURANCE', 'HOME')">
          EXPLORE MORE
        </button>
      </div>

      <!-- <div *ngIf="CongratulationScreen && bflJourney || setTimerCall == 0">
        <div class="col-md-12 rating-section bottom-margin-40">
          <h2 class="mb-05 rating-label">Tell us how you loved the app by rating your experience</h2>
          <div class="text-center">
            <rating [max]="5" [(ngModel)]="rate" [max]="max" [readonly]="isReadOnly" (keyup)="confirmSelection($event)">
            </rating>
          </div>
          <h2 class="rate-us-lable cursor-pointer bottom-spc-10">RATE US NOW
            <i class="icon-spec-value icon-a_downward_arrow hightlight-color cursor-pointer details-dropdown"></i>
          </h2>
        </div>
      </div> -->
    </div>
  </div>
</div>





<section class="col main-content p-md-0 no-pad hide-desktop">
  <section *ngIf="showLoader">
    <app-loader></app-loader>
  </section>
  <div class="flex-container col-md-12 no-pad">
    <div class="flex-item no-border-radius flex-error-item">
      <div class="col-md-12 error-section d-flex ">
        <div class="col-xs-3 col-4 col-md-3 center">
          <img style="height: 70px" class="vehicles-logo" src="assets/congratulation.png">
        </div>
        <div class="col-md-9 col-9">
          <!-- <h2 *ngIf="CongratulationScreen" class="mb-05 error-label">Success!</h2> -->
          <h2 *ngIf="CongratulationScreen  && morethan30 || setTimerCall == 0" class="mb-05 error-label">
            Congratulations!</h2>
          <h2 *ngIf="CongratulationScreen && policyDownloadResponseList && !bothPoliciesNull && !morethan30"
            class="mb-05 error-label">Success!</h2>
          <!-- <h2 *ngIf="!CongratulationScreen" class="mb-05 error-label">Hurray!</h2>
                  <p class="payment-desc" *ngIf="!CongratulationScreen" > Payment successful. Your policy issuance is in progress.</p> -->
        </div>
      </div>
      <div *ngIf="CongratulationScreen  && morethan30 || setTimerCall == 0" class="col-md-12 transaction-msg">
        Your payment is successful and you will receive your policy details on your registered mobile
        number and Email ID within 7 working days
      </div>
      <div *ngIf="CongratulationScreen && policyDownloadResponseList && !bothPoliciesNull && !morethan30"
        class="col-md-12 transaction-msg">
        Payment successful. Congratulations on securing your health!
      </div>
    </div>

    <!-- <div *ngIf="CongratulationScreen || setTimerCall == 0" class="flex-item no-border-radius flex-error-item">
      <div class="col-md-12 rating-section">
        <h2 class="mb-05 rating-label">Tell us how you loved the app by rating your experience</h2>
        <div class="text-center">
          <rating [max]="5" [(ngModel)]="rate" [max]="max" [readonly]="isReadOnly" (keyup)="confirmSelection($event)">
          </rating>
        </div>
        <h2 class="rate-us-lable cursor-pointer bottom-spc-10">RATE US NOW
          <i class="icon-spec-value icon-a_downward_arrow hightlight-color cursor-pointer details-dropdown"></i>
        </h2>
      </div>
    </div> -->

    <div class="flex-item no-border-radius flex-error-item">

      <ng-container *ngIf="quoteDetail && aemFragmentInfo">
        <app-plan-card [selectedSumAssured]="selectedSumAssured" [selectedTenure]="quoteItemDetail.tenure"
          [cashlessHospitalcount]="cashlessHospitalcount" [selectedSumAssuredAddOn]="selectedSumAssuredAddOn"
          [totalGrossPremium]="quoteDetail.grossPremiumAmount" [planCode]="quoteDetail.productCode"
          [tags]="quoteDetail.producttype" [variantCode]="variantCode" [aemFragmentInfo]="aemFragmentInfo">
        </app-plan-card>
      </ng-container>

      <!-- <div class="cards d-flex kyc-disclaimer-mobile ">
        <img src="../../../assets/icon/Info-icon-kyc.png" class="kyc-icon-mobile">
        <span class="kyc-top-mobile">{{disclaimer_msg}}</span>
      </div> -->

      <div *ngIf="paymentDetail && paymentDetail.paymentMode && (paymentDetail.paymentMode === 'FUNDED' || 
      paymentDetail.paymentMode === 'PARTIALLY FUNDED' || paymentDetail.paymentMode === 'FULLY FUNDED')"
        class="emi-details-section">
        <div class="emi-details">
          <span>Loan Account Number</span>
          <span class="amount-Label">
            {{loanAccountNumber}}</span>
        </div>
        <div class="emi-details">
          <span>Advance EMI</span>
          <span class="amount-Label">
            Rs. {{fundingAmount}}</span>
        </div>
        <div class="emi-details">
          <span>Loan Tenure</span>
          <span class="amount-Label">
            {{fundingTenor}} Months</span>
        </div>
        <div class="emi-details section-spc">
          <span>1st EMI Due Date</span>
          <span class="amount-Label">
            {{firstEmiDate}}</span>
        </div>
      </div>

      <ng-container>
        <div class="col-md-12 error-section pad-top-bottom-1 d-flex justify-content-between mt-10">
          <h2 class="mb-05 instapack-label">Policy Details</h2>
        </div>
        <div class="transaction-msg">
          <div *ngIf="policyDownloadResponseList && policyDownloadResponseList.length > 0">
            <div *ngFor="let policyDownloadResponse of policyDownloadResponseList; let i = index">
              <p class="instapack-desc">Policy Number
                <span class="flt-rght">
                  <div>
                    <div *ngIf="policyDownloadResponse.policyNumber" [ngClass]="i === 0 ? bottom-margin-20 : ''">
                      <h5 class="text-center font15 word-break">
                        <div>{{policyDownloadResponse.policyNumber}}
                        </div>
                      </h5>
                    </div>
                  </div>
                </span>
              </p>
              <p *ngIf="policyDownloadResponse.proposalNumber" class="instapack-desc">Application Number
                <span class="flt-rght">
                  <div>
                    <div [ngClass]="i === 0 ? bottom-margin-20 : ''">
                      <h5 class="text-center font15 word-break">
                        <div>{{ policyDownloadResponse.proposalNumber }}</div>
                      </h5>
                    </div>
                  </div>
                </span>
              </p>
            </div>
          </div>

          <div>
            <p class="instapack-desc">Transaction ID
              <span class="flt-rght">
                <div>
                  <div>
                    <h5 class="text-center font15 word-break">
                      <div> {{paymentId}} </div>
                    </h5>
                  </div>
                </div>
              </span>
            </p>
          </div>

          <div *ngIf="applicationId">
            <p class="instapack-desc">Application ID
              <span class="flt-rght">
                <div>
                  <div>
                    <h5 class="text-center font15 word-break">
                      <div> {{ applicationId }}</div>
                    </h5>
                  </div>
                </div>
              </span>
            </p>
          </div>

          <div *ngIf="quoteId">
            <p class="instapack-desc">Quote ID
              <span class="flt-rght">
                <div>
                  <div>
                    <h5 class="text-center font15 word-break">
                      <div> {{ quoteId }} </div>
                    </h5>
                  </div>
                </div>
              </span>
            </p>
          </div>

        </div>
      </ng-container>








    </div>

    <div class="flex-item no-border-radius flex-error-item"
      *ngIf="policyDownloadResponseList && policyDownloadResponseList.length > 0 && principalCode !== 'ABHI'">
      <h2 class="choose-product-heading">Download Documents</h2>

      <ng-container *ngFor="let policyDownloadResponse of policyDownloadResponseList; let i = index">
        <div class="col-md-12 rating-section policydoc-mob">
          <h2 class="mb-05 rating-label">Policy No - {{policyDownloadResponse.policyNumber}}
            <h4 class="download-text" *ngIf="principalCode !== 'ABHI' && planCode !== 'MAXBUPAIH'">Please click here to
              download your policy copy.
              <span *ngIf="planCode ==='MAXBUPAIH'"> This is password protected and the password is the Proposer's DOB
                in DDMMYYYY format</span>
            </h4>
            <span class="flt-rght cursor-pointer" *ngIf="principalCode !== 'ABHI' && planCode !== 'MAXBUPAIH'"
              (click)="DownloadPolicy(policyDownloadResponse)">
              <img class="vehicles-logo light-icon-display" src="assets/img/png/download_icon.png">
              <img class="vehicles-logo dark-icon-display" src="assets/download-dark.png">
            </span>
          </h2>
        </div>
      </ng-container>


    </div>

    <div *ngIf="CongratulationScreen || setTimerCall == 0"
      class="flex-item no-border-radius flex-error-item pad-bottom-70">
      <h2 class="choose-product-heading">People like you also bought <span class="badge">04</span></h2>
      <div class="col-md-12 rating-section1 p-0">
        <carousel [interval]="4000" [noPause]="true" class="loan-details-container home-slider">
          <ng-container *ngIf="finalBannerAemArray.length > 0">
            <ng-container *ngFor="let imageAem of finalBannerAemArray">
              <slide>
                <a href="{{imageAem?.redirectionURL}}" target="_blank">
                  <img src="{{imageAem?.imageIcon}}"
                    onerror="this.onerror=null;this.src='assets/img/png/bajajLogo-placeholder.png'"
                    style="display: block; width: 100%; height: 100%;">
                </a>
              </slide>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="finalBannerAemArray.length==0">
            <slide>
              <a href="https://www.bajajfinservmarkets.in/apply-for-personal-loan/" target="_blank">
                <img src="assets/img/png/bajajLogo-placeholder.png" style="display: block; width: 100%; height: 100%;">
              </a>
            </slide>
          </ng-container>
        </carousel>
      </div>
    </div>


    <div class="btn-fix-container">

      <!-- <button type="button" *ngIf="!CongratulationScreen && principalCode === 'BAGIC'" class="btn btn-primary btnconfirm btn-single pad0"
                (click)="Next()">
                PROCEED
            </button> -->

      <button type="button" *ngIf="CongratulationScreen || setTimerCall == 0"
        class="btn btn-primary btnconfirm btn-single pad0" (click)="ExploreMore('INSINSURANCE', 'HOME')">
        EXPLORE MORE
      </button>
    </div>


  </div>
</section>